import {
  FaStar,
  FaComments,
  FaSmile,
  FaReply,
} from "react-icons/fa";

import "./RatingSummary.css";

function RatingSummary({ reviews }) {
  const totalReviews = reviews.length;

  const totalRating = reviews.reduce(
    (sum, item) => sum + item.rating,
    0
  );

  const averageRating = totalReviews
    ? (totalRating / totalReviews).toFixed(1)
    : "0.0";

  const fiveStarReviews = reviews.filter(
    (item) => item.rating === 5
  ).length;

  const pendingReplies = reviews.filter(
    (item) => !item.reply
  ).length;

  const cards = [
    {
      title: "Overall Rating",
      value: averageRating,
      icon: <FaStar />,
      color: "#f59e0b",
    },
    {
      title: "Total Reviews",
      value: totalReviews,
      icon: <FaComments />,
      color: "#3b82f6",
    },
    {
      title: "5★ Reviews",
      value: fiveStarReviews,
      icon: <FaSmile />,
      color: "#22c55e",
    },
    {
      title: "Pending Replies",
      value: pendingReplies,
      icon: <FaReply />,
      color: "#ef4444",
    },
  ];

  return (
    <div className="rating-summary">

      {cards.map((card, index) => (
        <div
          className="summary-card"
          key={index}
        >
          <div
            className="summary-icon"
            style={{
              background: card.color,
            }}
          >
            {card.icon}
          </div>

          <div className="summary-content">
            <h2>{card.value}</h2>
            <p>{card.title}</p>
          </div>
        </div>
      ))}

    </div>
  );
}

export default RatingSummary;